// 😱 Effrayer — cache-cache : l'adversaire fait sa ronde sur la seconde moitié du chemin et regarde
// droit devant lui. Être vu fait perdre ; il faut l'atteindre par derrière ou par le côté.
import { baseState, countTick, finish, lineOfSight, sameCell, extendRivalTrail, headingOf, timeGain } from './common.js';

export const SIGHT_CELLS = 4;

const facing = (from, to) => ({ dx: Math.sign(to.x - from.x), dy: Math.sign(to.y - from.y) });

function look(state, grid) {
  return { ...state, sight: lineOfSight(grid, state.rival, state.facing, SIGHT_CELLS) };
}

/** Joueur atteint (gagné) ou vu (perdu). */
function check(state, player) {
  if (sameCell(state.rival, player)) return finish(state, 'win');
  if (state.sight.some((cell) => sameCell(cell, player))) return finish(state, 'lose', 'spotted');
  return state;
}

export const scare = {
  id: 'scare',
  create(ctx) {
    const length = Math.max(1, ctx.path.length - 1);
    const route = ctx.path.slice(Math.floor(length / 2));
    const index = route.length - 1;
    const rival = route[index];
    const ahead = route[index - 1] ?? rival;
    const state = baseState(ctx, {
      rival,
      budget: Math.max(10, length * 3),
      idleTicks: 4,
      route,
      index,
      direction: -1,
      facing: facing(rival, ahead),
      heading: headingOf(rival, ahead),
    });
    return look(state, ctx.grid);
  },
  tick(state, { grid, player }) {
    let next = countTick(state);
    if (next.result) return next;
    const target = next.index + next.direction;
    if (target < 0 || target >= next.route.length) {
      // Bout de la ronde : demi-tour sur place
      const direction = -next.direction;
      const ahead = next.route[next.index + direction] ?? next.rival;
      next = { ...next, direction, facing: facing(next.rival, ahead), heading: headingOf(next.rival, ahead) || next.heading };
    } else {
      const to = next.route[target];
      if (sameCell(to, player)) return finish(next, 'lose', 'spotted'); // il lui tombe dessus
      next = {
        ...next,
        index: target,
        facing: facing(next.rival, to),
        heading: headingOf(next.rival, to) || next.heading,
        rival: to,
        trail: extendRivalTrail(next.trail, to),
      };
    }
    return check(look(next, grid), player);
  },
  enter: (state, { player }) => check(state, player),
  gain: (state) => timeGain(state.fullGain, state.ticks, state.budget),
  isIdle: (state) => state.ticks >= state.idleTicks,
  hints: (state) => [{ key: 'scenario.scare.hint.rival', cell: state.rival }],
};
